export default __webpack_public_path__ + "static/media/logo.dc8e4905.svg";